// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._errNotice[data-v-4396fb69]{padding:calc(var(--spacing)/2)}._spaceView[data-v-4396fb69]{margin:0 auto}._topSpace[data-v-4396fb69]{max-width:min(var(--max-column-width),1080px)}._projectsList[data-v-4396fb69],._topSpace[data-v-4396fb69]{margin:calc(var(--spacing)*1) auto 0}._projectsList[data-v-4396fb69]{max-width:var(--max-column-width)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
